import { render, staticRenderFns } from "./new3.vue?vue&type=template&id=60ff1bb4&scoped=true&"
import script from "./new3.vue?vue&type=script&lang=js&"
export * from "./new3.vue?vue&type=script&lang=js&"
import style0 from "./new3.vue?vue&type=style&index=0&id=60ff1bb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff1bb4",
  null
  
)

export default component.exports